import history from './history';
import store from "../redux/clientStore.js";

export function navigateToEntranceIfGiven(url) {
	const storedEntrance = store.getState().sponsorCodes.entranceUrl;
	history.push(storedEntrance ? storedEntrance : url);
}
